<template>
  <div v-show="show">
    <div class="layout-footer" v-if="!list.length">
      <van-tabbar :safe-area-inset-bottom="false">
        <van-tabbar-item v-for="(item, index) in footerArr" :key="'footer-' + index" :class="{ active: curRoute.search(item.url) !== -1 || curRoute === item.link ? true : false }" active-color="#0190fe" inactive-color="#999" @click.native.stop.prevent="onChange(index)">
          <span>{{ item.title }}</span>
          <template #icon="props">
            <img :src="item.activeIcon" v-if="curRoute.search(item.url) !== -1" />
            <img :src="item.icon" v-else />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="layout-footer" v-else>
      <van-tabbar :safe-area-inset-bottom="false">
        <van-tabbar-item v-for="(item, index) in list" :key="'footer-' + index" :class="{ active: curRoute.search(item.wapUrl) !== -1 || curRoute === item.link ? true : false }" active-color="#0190fe" inactive-color="#999" @click.native.stop.prevent="linkToHandle(item.wapUrl)">
          <span>{{ item.name }}</span>
          <template #icon="props">
            <img :src="item.icon" class="icon-img" :class="{ active: curRoute.search(item.wapUrl) !== -1 }" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import homeIcon from "@assets/img/footer/homeIcon.png";
import acthomeIcon from "@assets/img/footer/acthomeIcon.png";
import zxIcon from "@assets/img/footer/zxIcon.png";
import actzxIcon from "@assets/img/footer/actzxIcon.png";
import proIcon from "@assets/img/footer/proIcon.png";
import actproIcon from "@assets/img/footer/actproIcon.png";
import actIcon from "@assets/img/footer/actIcon.png";
import actactIcon from "@assets/img/footer/actactIcon.png";
import newsIcon from "@assets/img/footer/newsIcon.png";
import actnewsIcon from "@assets/img/footer/actnewsIcon.png";
import boothIcon from "@assets/img/footer/boothIcon.png";
import actboothIcon from "@assets/img/footer/actboothIcon.png";
export default {
  name: "layout-footer",
  props: {
    isHeadLines: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      arr: "set/getFooterArr",
      exhibitionId: "getExhibitionId",
      userId: "getUserId",
      userInfo: "getUserInfo", //观众信息
      roomid: "getRoomid", //roomId
      exhibitionConfig: "getExhibitionConfig",
    }),
    footerArr () {
      return [
        {
          title: "Home",
          url: `/home/${this.exhibitionId}`,
          icon: homeIcon,
          activeIcon: acthomeIcon,
        },
        {
          title: "Exhibitors",
          url: `/exhibition/${this.exhibitionId}`,
          icon: zxIcon,
          activeIcon: actzxIcon,
        },
        {
          title: "Products",
          url: `/product/${this.exhibitionId}`,
          icon: proIcon,
          activeIcon: actproIcon,
        },
        {
          title: "Activities",
          url: `/activity/${this.exhibitionId}`,
          icon: actIcon,
          activeIcon: actactIcon,
        },
        {
          title: "Floorplans",
          url: `/boothView/${this.exhibitionId}`,
          icon: boothIcon,
          activeIcon: actboothIcon,
        },
        // {
        //   title: "头条",
        //   url: `/news/${this.exhibitionId}`, 
        //   icon: newsIcon,
        //   activeIcon: actnewsIcon,
        // },
      ];
    },
    curRoute () {
      return this.$router.history.current.fullPath;
    },
    option () {
      return {
        where: {
          Equal2: {
            N: "exhibitionId",
            V: this.exhibitionId,
          },
          Equal_isdeleted: {
            n: "isDeleted",
            v: false,
          },
          Equal_lang: { N: "langVersion", V: this.lang },
        },
        order: [{ N: "showIndex", V: 1 }],
      };
    },
    isShowTab () {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.display &&
        this.exhibitionConfig.display.enabledCustomMTab
      );
    },
  },
  data () {
    return {
      list: [],
      lang: "en",
      show: false,
    };
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      LinkFooter: "linkTo/LinkFooter",
      getWebTab: "set/getWebTab",
    }),
    async init () {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 2000);
      let listData = await this.getWebTab(this.option);
      this.show = true;
      if (
        listData &&
        listData.items &&
        listData.items.length &&
        this.isShowTab
      ) {
        this.list = listData.items;
      }
    },
    onChange (idx) {
      const cur = this.footerArr[idx];
      console.log('onChange', cur.url);
      let opt = {
        url: cur.url,
      };
      if (cur && cur.url) {
        this.LinkFooter(opt);
      }
    },
    linkToHandle (url) {
      if (url) {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-footer {
  ::v-deep .active {
    color: #0190fe !important;
  }
  ::v-deep .van-tabbar-item--active {
    color: #646566;
  }
  ::v-deep .icon-img {
    width: 0.4rem;
    height: 0.4rem;
    filter: grayscale(100%);
    &.active {
      filter: grayscale(0);
    }
  }
}
</style>
